import styled from 'styled-components';
import MuiTableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';

export interface TableContainerProps {
  $minWidth?: number;
}

export const TableContainer = styled(MuiTableContainer).attrs({
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  component: Paper,
})<TableContainerProps>`
  &.MuiPaper-root {
    box-shadow: none;
    background-color: ${({ theme }) => theme.colors.transparent};
    min-width: ${({ $minWidth }) => `${$minWidth || 500}px`};
  }
`;
